export default "/institutions/bank-of-america.svg";